import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJRecorderDelay from '../view/FJRecorderDelay';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionRecord from '../../../../redux/action/FJActionRecord.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import FJEvent from '../../../../store/FJEvent.js';

const FJRecorderDelayContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isShowRecorderDelay = useSelector(state => state.record.isShowRecorderDelay);

    const clickStopRecord = () => {
        dispatch(FJActionRecord.setIsShowRecorderDelayAction(false));
    };

    const onCountDownEnd = () => {
        dispatch(FJActionRecord.setIsShowRecorderDelayAction(false));
        FJEvent.dispatch(FJ_EVENT_TYPE.START_RECORDER);
    };

    return isShowRecorderDelay && <FJRecorderDelay clickStopRecord={clickStopRecord} onCountDownEnd={onCountDownEnd} />;
};

export default React.memo(FJRecorderDelayContainer);
